import React, { useState } from 'react';
import { useModal } from 'hooks/useModal';
import { FormInput } from 'components/form';
import { Search } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { MUITable } from 'components/shared/MUITable';
import { Box, Button, InputAdornment } from '@mui/material';
import { APIRequestPagination, APIRequestSort, ModalsKeys } from 'global';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { CustomerTableRow } from '../../../types';
import { customersTableColumns } from '../../../constants';
import { useCustomersPage } from '../../../hooks/useCustomersPage';

export const CustomersListCard = () => {
  const history = useHistory();
  const { handleOpen } = useModal(ModalsKeys.CustomerAccountDialog);

  const [searchValue, setSearchValue] = useState<string>('');
  const [sorting, setSorting] = useState<APIRequestSort>({ key: 'lastContactDate', value: 'desc' });
  const [pagination, setPagination] = useState<APIRequestPagination>({ page: 1, perPage: 15 });

  const { isLoading, customers, total } = useCustomersPage(searchValue, pagination, sorting);

  const handleRowClick = (_: React.MouseEvent<HTMLTableRowElement, MouseEvent>, row: CustomerTableRow) => {
    history.push(`/customers/${row.id}`);
  };

  return (
    <CardContainer
      title="List"
      actionBtn={
        <Button variant="contained" onClick={() => handleOpen()}>
          Add Customer
        </Button>
      }
    >
      <FormInput
        label="Search"
        variant="outlined"
        value={searchValue}
        onChange={value => setSearchValue(value)}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          },
        }}
      />

      <Box sx={{ height: 'calc(100% - 6rem)' }}>
        <MUITable<CustomerTableRow>
          hover
          stickyHeader
          isLoading={isLoading}
          tableData={customers}
          onRowClick={handleRowClick}
          columns={customersTableColumns}
          sorting={{ ...sorting, onChange: setSorting }}
          pagination={{
            ...pagination,
            total,
            onChange: nextValue => setPagination(prev => ({ ...prev, ...nextValue })),
          }}
        />
      </Box>
    </CardContainer>
  );
};
